module.exports = __webpack_public_path__ + "static/img/logo-main.4a7584f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-main.svg
// module id = 388
// module chunks = 1